import { authLoginFormLocaleTexts } from './login/form'

export const authLocaleTexts = {
  login: {
    form: authLoginFormLocaleTexts,
  },
}
